import { Card, List, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { useAppSelector } from "@/config/store";
import { IEdoClassZoomLink } from "@/shared/model/edo-class-zoom-link.model";
import { IEdoClass } from "@/shared/model/edo-class.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { Video } from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { Translate } from "react-jhipster";

interface IZoomLinksBoxProps {
  class: IEdoClass;
}

const ZoomLinksBox = (props: IZoomLinksBoxProps) => {
  const [classZoomLinks, setClassZoomLinks] = useState<IEdoClassZoomLink[]>([]);
  const { updateSuccess } = useAppSelector<EntityState<IEdoClassZoomLink>>(
    (state) => state.edoClassZoomLink
  );
  const { class: edoClass } = props;

  const getClassZoomLinks = async () => {
    const response = await axios.get<{ data: IEdoClassZoomLink[] }>(
      `/classes/${edoClass.id}/zoom-links`
    );
    setClassZoomLinks(response.data.data);
  };

  useEffect(() => {
    if (edoClass?.id) getClassZoomLinks();
  }, [edoClass?.id]);

  useEffect(() => {
    if (updateSuccess) getClassZoomLinks();
  }, [updateSuccess]);

  return (
    <Card className="surface overflow-hidden p-0">
      <div className="border-b border-[var(--color-mockup-border)] px-4 py-3">
        <h3 className="font-heading text-base font-bold text-[var(--color-mockup-text)]">
          <Translate contentKey="edocendoApp.edoClassZoomLink.home.title" />
        </h3>
      </div>
      <List>
        {classZoomLinks.length ? (
          classZoomLinks.map((classZoomLink) => (
            <ListItem
              key={classZoomLink.id}
              className="flex cursor-pointer items-center gap-3 transition-colors hover:bg-primary/5"
              onClick={() => window.open(classZoomLink.zoomInviteLink, "_blank")}
            >
              <ListItemIcon className="mr-0 shrink-0">
                <Video className="h-5 w-5 text-[var(--color-mockup-text-light)]" />
              </ListItemIcon>
              <ListItemText primary={classZoomLink.label} />
            </ListItem>
          ))
        ) : (
          <li className="px-4 py-4 text-center text-body-sm text-[var(--color-mockup-text-light)]">
            <Translate contentKey="edocendoApp.edoClassZoomLink.home.notFound" />
          </li>
        )}
      </List>
    </Card>
  );
};

export default ZoomLinksBox;
